function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.01,
  d: "M0 0h24v24H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.964 5h-3.379v5.585H5v3.38h5.585v5.585h3.38v-5.586h5.585v-3.379h-5.586V5z",
  fill: "current"
});

function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgPlus;